import { Component, type ReactNode } from 'react'
import { AlertTriangle, RefreshCw } from 'lucide-react'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

/**
 * \u9876\u5c42\u9519\u8bef\u8fb9\u754c\u3002
 *
 * React \u5728\u6e32\u67d3\u5230\u4e0d\u5408\u6cd5\u5b50\u8282\u70b9\uff08\u4f8b\u5982\u8bef\u4f20\u5bf9\u8c61\uff09\u65f6\u4f1a\u5378\u8f7d\u6574\u68f5\u7ec4\u4ef6\u6811\uff0c
 * \u5bfc\u81f4\u9875\u9762\u53d8\u4e3a\u7a7a\u767d/\u9ed1\u5c4f\u3002\u5305\u4e00\u5c42\u9519\u8bef\u8fb9\u754c\u540e\uff0c\u53ef\u4ee5\u5728\u9519\u8bef\u53d1\u751f\u65f6\u5c55\u793a
 * \u53cb\u597d\u7684\u5907\u7528\u754c\u9762\uff0c\u800c\u4e0d\u662f\u76f4\u63a5\u9ed1\u5c4f\u3002
 */
export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, info: unknown) {
    // \u6700\u5c11\u8bb0\u5f55\u5230\u63a7\u5236\u53f0\uff0c\u65b9\u4fbf\u6392\u67e5
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary] caught:', error, info)
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null })
    window.location.href = '/'
  }

  render() {
    if (!this.state.hasError) return this.props.children

    return (
      <div
        style={{
          minHeight: '100dvh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 24,
          gap: 16,
          textAlign: 'center',
        }}
        className="bg-bg"
      >
        <div
          style={{ width: 64, height: 64, borderRadius: 16, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          className="bg-danger/10"
        >
          <AlertTriangle style={{ width: 32, height: 32 }} className="text-danger" />
        </div>
        <div>
          <p style={{ fontSize: 16, fontWeight: 600 }} className="text-text-primary">\u9875\u9762\u6e32\u67d3\u51fa\u9519</p>
          <p style={{ fontSize: 13, marginTop: 6, maxWidth: 320 }} className="text-text-muted">
            {this.state.error?.message || '\u53d1\u751f\u4e86\u672a\u77e5\u9519\u8bef\uff0c\u8bf7\u8fd4\u56de\u9996\u9875\u91cd\u8bd5\u3002'}
          </p>
        </div>
        <button
          onClick={this.handleReload}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '10px 20px',
            borderRadius: 12,
            borderWidth: 1,
            fontSize: 14,
            fontWeight: 500,
          }}
          className="bg-primary/10 border-primary/30 text-primary cursor-pointer active:scale-[0.99] transition-all duration-150"
        >
          <RefreshCw style={{ width: 16, height: 16 }} />
          <span>\u8fd4\u56de\u9996\u9875</span>
        </button>
      </div>
    )
  }
}
